<template>
  <div class="base-rich-text" :class="`base-rich-text--${variant}`" v-html="html" />
</template>

<script setup lang="ts">
  const { html, variant = 'default' } = defineProps<{
    html: string;
    variant?: 'none' | 'default';
  }>();
</script>

<style lang="postcss">
  .base-rich-text {
    &--default {
      p {
        margin-bottom: var(--spacing-4);
      }

      > :where(*:not(:last-child)) {
        margin-bottom: var(--spacing-3);
      }

      > :where(ul, ol) {
        padding-left: var(--spacing-3);
      }

      :where(ul, ol) {
        list-style: disc;
        list-style-position: outside;

        li {
          margin-left: var(--spacing-4);
          text-wrap: balance;
        }
      }

      :where(b, strong) {
        font: var(--typography-small-body-base-highlight);
      }

      a {
        text-decoration: underline;
      }

      h4 {
        margin-bottom: var(--spacing-2);
        font: var(--typography-small-h4);

        @media (--screen-xl) {
          font: var(--typography-large-h4);
        }
      }

      h5 {
        margin-bottom: var(--spacing-2);
        font: var(--typography-small-h5);

        @media (--screen-xl) {
          font: var(--typography-large-h5);
        }
      }
    }
  }
</style>
